import { __ } from '@wordpress/i18n';
import { Modal } from '@wordpress/components';

const ImageModal = ({ imageUrl, onClose }) => {
    if (!imageUrl) return null;

    return (
        <Modal
            title={__('Image Preview', 'media-trim')}
            onRequestClose={onClose}
            className="mtrim-image-preview-modal"
        >
            <div className="mtrim-modal-image-container">
                <img 
                    src={imageUrl} 
                    alt={__('Preview', 'media-trim')} 
                />
            </div>
        </Modal>
    );
};

export default ImageModal;
